import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { nextTick, ref, watch } from 'vue'

import TransportationForm from '../forms/TransportationForm.vue'
import ProductTour from '@/components/core/productTour/ProductTour.vue'
import ProductTourOverlay from '@/components/core/productTour/ProductTourOverlay.vue'
import { useTransportationStore } from '@/stores/transportation'

// Tour configuration

export default /*#__PURE__*/_defineComponent({
  __name: 'TransportationSlideOver',
  setup(__props) {

const TRANSPORTATION_TOUR_KEY = 'transportation-basics'

const transportationStore = useTransportationStore()
const { selectedTransportation } = storeToRefs(transportationStore)

// Open State Management -------------------------------------------------------
function closeSlideOver() {
  if (isOpen.value) {
    isOpen.value = false
  }
}

const isOpen = ref(false)

watch(
  selectedTransportation,
  (newValue) => {
    if (newValue) {
      nextTick(() => {
        isOpen.value = true
      })
    } else {
      isOpen.value = false
    }
  },
  {
    immediate: true,
  },
)

return { __sfc: true,TRANSPORTATION_TOUR_KEY, transportationStore, selectedTransportation, closeSlideOver, isOpen, TransportationForm, ProductTour, ProductTourOverlay }
}

})